import script from "./SearchWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchWidget.vue?vue&type=script&setup=true&lang=js"

import "./SearchWidget.vue?vue&type=style&index=0&id=46bffa64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46bffa64"]])

export default __exports__